var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useParams } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { LoadingPane } from "@folio/stripes/components";
import { LibraryForm } from "../../components/library/LibraryForm";
import { fetchLibraryById, updateLibrary } from "../../api/libraryService";
import { ROUTE_PATHS } from "../../types/routePaths";
import { useListReturn } from "../../utils/listReturn";
import { libraryMessageTemplatesKey } from "../../hooks/useLibraryMessageTemplates";
var LibraryEdit = function () {
    var kyInstance = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var libraryId = useParams().id;
    var queryClient = useQueryClient();
    var returnToList = useListReturn("".concat(ROUTE_PATHS.LIBRARIES, "?detail=").concat(libraryId));
    var _a = useQuery(["library", libraryId], function () { return fetchLibraryById(kyInstance, libraryId); }, {
        enabled: !!libraryId,
    }), library = _a.data, isLibraryLoading = _a.isLoading, isLibraryError = _a.isError;
    var updateLibraryMutation = useMutation(function (libraryData) {
        return updateLibrary(kyInstance, libraryId, libraryData);
    }, {
        onSuccess: function () {
            queryClient.invalidateQueries(["library", libraryId]);
            queryClient.invalidateQueries(["libraries"]);
            queryClient.invalidateQueries(libraryMessageTemplatesKey(libraryId));
            returnToList();
        },
    });
    var handleSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateLibraryMutation.mutateAsync(formData)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    if (isLibraryLoading) {
        return React.createElement(LoadingPane, null);
    }
    if (isLibraryError || !library) {
        return (React.createElement("div", null, formatMessage({ id: "ui-br-legaldeposits.error.library.not.found" })));
    }
    return (React.createElement(LibraryForm, { initialValues: library, onSubmit: handleSubmit, title: formatMessage({
            id: "ui-br-legaldeposits.libraries.edit.pane.title",
        }), onCancel: returnToList }));
};
export default LibraryEdit;
